<script setup>
  import { computed } from 'vue';
  import DataContainer from "@/components/DataContainer.vue";
  import CurrentConditionsData from "@/components/CurrentConditionsData.vue";
  import CurrentConditionsLastUpdateTimestamp from './CurrentConditionsLastUpdateTimestamp.vue';

  const emit = defineEmits(['data-item:click']);

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    },
    useButtons: {
      type: Boolean,
      default: false
    },
    showLastUpdateTimestamp: {
      type: Boolean,
      default: false
    },
    spotDataObject: {
      type: Object,
      required: true
    }
  });

  const dataItemClickEvent = computed(() => {
    if (!props.useButtons) return {};

    return { 'data-item:click': handleDataListItemClick };
  });

  function handleDataListItemClick(event) {
    emit('data-item:click', event);
  }  
</script>

<template>
  <DataContainer class="jwx-complete-report-data" >
    <CurrentConditionsLastUpdateTimestamp v-if="props.showLastUpdateTimestamp" />

    <CurrentConditionsData
      :upgrade="props.upgrade"
      :useButtons="props.useButtons"
      :spotDataObject="props.spotDataObject"
      v-on="dataItemClickEvent"
    />
  </DataContainer>
</template>